import { FormControl, FormGroup, Validators } from '@angular/forms';

export class ComplianceFindingForm extends FormGroup<{
  id: FormControl<number | undefined>;
  ClientRegisteredVendorId: FormControl<number | null | undefined>;
  companyIdentity: FormControl<number | null>;
  companyWatchlist: FormControl<number | null>;
  companyInGoodStanding: FormControl<boolean | null>;
  bankruptcy: FormControl<number | null>;
  companyLiens: FormControl<number | null>;
  w9Check: FormControl<boolean | null>;

  companyBusinessVerified: FormControl<boolean | null>;
  companyGovernmentWatchlist: FormControl<number | null>;
  companyAddress: FormControl<
    'Verified' | 'Not Matching' | 'Not Required' | null
  >;
  companySecretaryOfState: FormControl<
    | 'Not Required'
    | 'In Good Standing'
    | 'Inactive'
    | 'Not In Good Standing'
    | 'Manual Review Needed'
    | 'No Records Found'
    | null
  >;
  companyBankruptcy: FormControl<number | null>;
  companyLiensAndJudgments: FormControl<number | null>;
  companyW9Check: FormControl<boolean | null>;
  companyRequester: FormControl<
    | 'Matching'
    | 'Likely Matching'
    | 'Not Matching'
    | 'Unknown'
    | 'Not Entered'
    | null
  >;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      ClientRegisteredVendorId: new FormControl<number | null | undefined>(
        null,
        { validators: [Validators.required] }
      ),
      companyIdentity: new FormControl<number | null>(null),
      companyWatchlist: new FormControl<number | null>(null),
      companyInGoodStanding: new FormControl<boolean | null>(null),
      bankruptcy: new FormControl<number | null>(null),
      companyLiens: new FormControl<number | null>(null),
      w9Check: new FormControl<boolean | null>(null),

      companyBusinessVerified: new FormControl<boolean | null>(null),
      companyGovernmentWatchlist: new FormControl<number | null>(null),
      companyAddress: new FormControl<
        'Verified' | 'Not Matching' | 'Not Required' | null
      >(null),
      companySecretaryOfState: new FormControl<
        | 'Not Required'
        | 'In Good Standing'
        | 'Inactive'
        | 'Not In Good Standing'
        | 'Manual Review Needed'
        | 'No Records Found'
        | null
      >(null),
      companyBankruptcy: new FormControl<number | null>(null),
      companyLiensAndJudgments: new FormControl<number | null>(null),
      companyW9Check: new FormControl<boolean | null>(null),
      companyRequester: new FormControl<
        | 'Matching'
        | 'Likely Matching'
        | 'Not Matching'
        | 'Unknown'
        | 'Not Entered'
        | null
      >(null)
    });
  }
}
